import { AbstractLifeCycle } from '@datadog/browser-core';
export const LifeCycle = (AbstractLifeCycle);
